import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import routes from 'app/routes';
import { useContext as useUsersContext } from 'components/Users/Context';

import Show from './Views/Show/Index';

export default function Main() {
  const { dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  const router = createBrowserRouter([
    {
      path: routes.coaches.show(),
      element: <Show />,
    },
  ]);

  return (
    <RouterProvider router={router} />
  );
}
